import { Download, ListFilter, Plus, QrCode, RefreshCw, type LucideIcon } from 'lucide-react';

/** The pictures a button can carry; the kit draws them, so a page names one and imports no icon. */
export type ActionIcon = 'refresh' | 'qr' | 'plus' | 'filter' | 'download';

const GLYPHS = { refresh: RefreshCw, qr: QrCode, plus: Plus, filter: ListFilter, download: Download } as const satisfies Record<ActionIcon, LucideIcon>;

export function ActionGlyph({ icon }: { readonly icon: ActionIcon }) {
  const Glyph = GLYPHS[icon];
  return <Glyph aria-hidden="true" />;
}
